/**
 * A 1px divider pinned to the right edge of the last fixed (sticky-left)
 * column in a horizontally-scrolling table, so the frozen columns stay
 * visually separated from the scrolling data (Andressa design review).
 *
 * Rendered as an absolutely-positioned element INSIDE the sticky cell —
 * not a cell `box-shadow`, which browsers don't paint on
 * `border-collapse` tables. The host cell is `position: sticky` (a
 * positioned ancestor), so the line rides the sticky boundary on
 * horizontal scroll and stacks across rows into one continuous rule.
 *
 * `mdOnly` matches tables whose columns are only sticky at `md+`
 * (e.g. the Operational staffing table drops sticky on mobile).
 */
export function StickyColDivider({
    mdOnly = false,
    side = "right",
}: {
    mdOnly?: boolean;
    /**
     * Which edge of the host cell the line rides. `right` is the default,
     * for the usual left-frozen columns. A column frozen to the RIGHT — the
     * Invoice table's Actions column — needs `left`, so the rule sits
     * between the scrolling data and the pinned column instead of on the
     * table's outer edge where nothing can see it.
     */
    side?: "left" | "right";
}) {
    return (
        <div
            aria-hidden="true"
            className={`bg-border-secondary pointer-events-none absolute inset-y-0 w-px ${
                side === "left" ? "left-0" : "right-0"
            }${mdOnly ? " hidden md:block" : ""}`}
        />
    );
}
